import React from "react";
import Particles from "react-tsparticles";

// Phones get fewer particles, a lower frame cap and no retina canvas to save
// battery; reduced-motion users get a static starfield.
const isMobile =
  typeof window !== "undefined" &&
  window.matchMedia("(max-width: 767px), (pointer: coarse)").matches;
const reduceMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function Particle() {
  return (
    <Particles
      id="tsparticles"
      params={{
        fpsLimit: isMobile ? 30 : 60,
        particles: {
          number: {
            value: isMobile ? 70 : 160,
            density: {
              enable: true,
              value_area: 1500,
            },
          },
          line_linked: {
            enable: false,
            opacity: 0.03,
          },
          move: {
            enable: !reduceMotion,
            direction: "right",
            speed: 0.05,
          },
          size: {
            value: 1,
          },
          opacity: {
            anim: {
              enable: !reduceMotion,
              speed: 1,
              opacity_min: 0.05,
            },
          },
        },
        interactivity: {
          detectsOn: "window",
          events: {
            onclick: {
              enable: !isMobile,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            push: {
              particles_nb: 1,
            },
          },
        },
        retina_detect: !isMobile,
      }}
    />
  );
}

export default Particle;
